module.exports = __webpack_public_path__ + "static/media/listcourse_banner.326c9ac9.svg";